import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { useBillingContext } from "./BillingContext";

const localeRoot = "settings.billing.manage_billing.plan_details";

export const NotIncludedFeatures = () => {
  const { currentPlan } = useBillingContext();

  if (!currentPlan) return null;

  return (
    <div>
      <Typography.LabelSm weight="medium">
        {t(`${localeRoot}.not_included`)}
      </Typography.LabelSm>
      <Typography.BodySm>
        <Icon
          type="16-cross"
          size={16}
          useWithFillCurrentColor
          useWithStrokeCurrentColor
          className="mr-2 text-red-500"
        />
        {t(`${localeRoot}.not_included_features.${currentPlan.tier}`)}
      </Typography.BodySm>
    </div>
  );
};
